import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=2933bff0&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=2933bff0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2933bff0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre预发布-anjun-express-web-management/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2933bff0')) {
      api.createRecord('2933bff0', component.options)
    } else {
      api.reload('2933bff0', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=2933bff0&scoped=true", function () {
      api.rerender('2933bff0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bulkyExpress/largeOrderManagement/component/detail.vue"
export default component.exports